import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SavedModelPortfoliosState } from './+state/saved-model-portfolios/saved-model-portfolios.interfaces';
import { SubscribedModelPortfoliosState } from './+state/subscribed-model-portfolios/subscribed-model-portfolios.interfaces';

export const getSavedModelPortfoliosState = createFeatureSelector<SavedModelPortfoliosState>('savedModelPortfolios');

export const getSavedModelPortfolioIdMappings = createSelector(
	getSavedModelPortfoliosState,
	state => state.savedPortfolioMapping
);

export const getSubscribedModelPortfoliosState = createFeatureSelector<SubscribedModelPortfoliosState>('subscribedModelPortfolios');

export const getSubscribedModelPortfolioIdMappings = createSelector(
	getSubscribedModelPortfoliosState,
	state => state.subscribedPortfolioMapping
);

export const getSavedModelPortfolioIds = createSelector(
	getSavedModelPortfolioIdMappings,
	state => Array.from(state.keys())
);

export const getSubscribedModelPortfolioIds = createSelector(
	getSubscribedModelPortfolioIdMappings,
	state => Array.from(state.keys())
);
